import { Field, Form, Formik } from 'formik';
import { useRef } from 'react';
import * as Yup from 'yup';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';
import Label from '@/components/Label';
import { InputField } from '../../components/formFields/InputField';
import { SelectFormField } from '../../components/formFields/SelectFormField';

interface FormProps {
  id?: string | number;
  title?: string;
  is_active?: number;
}

interface TemplateDialogProps {
  visible: boolean;
  onClose: () => void;
  formProps?: FormProps;
  onSubmit: (id: string | number | undefined, values: { title: string; is_active: number }) => void;
}

const TemplateDialog = ({ visible, onClose, formProps, onSubmit }: TemplateDialogProps) => {
  const formRef = useRef<any>(null);

  const ValidationSchema = Yup.object().shape({
    title: Yup.string().nullable().required('Povinné pole'),
  });

  const onSubmitButton = () => {
    if (!formRef?.current) return null;
    formRef.current.submitForm();
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{formProps ? 'Editace šablony' : 'Vytvoření šablony'}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            validationSchema={ValidationSchema}
            initialValues={{
              title: formProps?.title || null,
              is_active: formProps?.is_active ?? 1,
            }}
            onSubmit={(values) => {
              onSubmit(formProps?.id, values);
            }}
          >
            {(props) => {
              const { values } = props;
              return (
                <>
                  <Form>
                    <div>
                      <Label name="title" title="Název" required />
                      <Field
                        name="title"
                        value={values.title || null}
                        placeholder="Název"
                        component={InputField}
                      />
                    </div>

                    <div>
                      <Label name="title" title="Stav" />
                      <SelectFormField
                        name="is_active"
                        placeholder="Stav"
                        data={[
                          { title: 'aktivní', id: 1 },
                          { title: 'neaktivní', id: 2 },
                        ]}
                      />
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="template-dialog-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="template-dialog-confirm-btn"
            onClick={() => onSubmitButton()}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateDialog;
